import moment from 'moment';

export function TableGRE({ dates = [], searchValue }) {
  return (
    <table
      className="round-dg round-dg--light"
      style={{ minWidth: '720px' }}
    >
      <thead className="round-dg__header">
        <tr className="round-dg__row">
          <th className="round-dg__cell-header round-dg__cell-header--sm">Data</th>
          <th className="round-dg__cell-header round-dg__cell-header--sm u-text-center">Visualizações</th>
          <th className="round-dg__cell-header round-dg__cell-header--sm u-text-center">Visualizadores Únicos</th>
          <th className="round-dg__cell-header round-dg__cell-header--sm u-text-center">Horas Assistidas</th>
          <th className="round-dg__cell-header round-dg__cell-header--sm u-text-center">Concluídos</th>
        </tr>
      </thead>

      <tbody className="round-dg__body">
        {dates.length > 0 &&
          dates
            .filter(item => !searchValue || moment(item.period_start).format('DD/MM/YYYY').includes(searchValue.toLowerCase()))
            .map((item, i) => (
              <tr
                key={item.id}
                className={`round-dg__row`}
              >
                <th className="round-dg__cell-header round-dg__cell-header--sm round-dg__cell-header--row font-bold text-primary-dark">{moment(item.period_start).format('DD/MM/YYYY')}</th>
                <td className="round-dg__cell round-dg__cell--sm u-text-center">{item.views}</td>
                <td className="round-dg__cell round-dg__cell--sm u-text-center">{item.unique_viewers}</td>
                <td className="round-dg__cell round-dg__cell--sm u-text-center">{item.total_watched_hours}</td>
                <td className="round-dg__cell round-dg__cell--sm u-text-center">{item.completions}</td>
              </tr>
            ))}
      </tbody>
    </table>
  );
}
